import type { RepresentationSummary } from '../MyDashboard/service';

type RepresentationActivityOptions = {
    parseStringActive?: boolean;
};

const TRUE_ACTIVE_VALUES = new Set(['true', '1', 'yes', 'y', 'sim', 's']);
const FALSE_ACTIVE_VALUES = new Set(['false', '0', 'no', 'n', 'nao', 'não']);
const ACTIVE_STATUS_VALUES = new Set(['ativa', 'ativo', 'active', 'ativada']);
const INACTIVE_STATUS_VALUES = new Set(['inativa', 'inativo', 'inactive', 'desativada', 'desativado']);

const normalizeStatus = (value: unknown): string => {
    if (!value) return '';
    return value
        .toString()
        .trim()
        .toLowerCase()
        .replace(/[\s_-]+/g, '');
};

export const isRepresentationActive = (
    item: RepresentationSummary | undefined | null,
    options: RepresentationActivityOptions = {},
): boolean => {
    if (!item) return false;

    if (typeof item.active === 'boolean') return item.active;

    if (options.parseStringActive !== false && item.active != null) {
        const normalized = item.active.toString().trim().toLowerCase();
        if (TRUE_ACTIVE_VALUES.has(normalized)) return true;
        if (FALSE_ACTIVE_VALUES.has(normalized)) return false;
    }

    const normalizedStatus = normalizeStatus(item.status);
    if (ACTIVE_STATUS_VALUES.has(normalizedStatus)) return true;
    if (INACTIVE_STATUS_VALUES.has(normalizedStatus)) return false;

    return false;
};
